/**
 *   web菜单自定义配置
 *   接口地址: http://rap2.10niu.cn/organization/repository/editor?id=21&mod=566
 */
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const menuCustomization = {
	//  后台_菜单自定义配置_获取渠道配置列表
	getChannelConfigList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/customize-menu/v1/get_channel_config_list`,
			params
		});
	},
	//  后台_菜单自定义配置_开启关闭自定义菜单
	editMenuConfig(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/customize-menu/v1/edit_menu_config`,
			data: qs.stringify(data)
		});
	},
	//  后台_菜单自定义配置_获取学校配置列表
	getSchoolConfigList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/customize-menu/v1/get_school_config_list`,
			params
		});
	},
	//  后台_菜单自定义配置_获取菜单列表
	getImportResult(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/customize-menu/v1/get_menu_list`,
			params
		});
	},
	//  后台_菜单自定义配置_修改配置
	editMenuConfigInfo(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/customize-menu/v1/edit_menu_config_info`,
			data: qs.stringify(data)
		});
	}
};

export default menuCustomization;
